/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import style from './HeaderBar.scss?inline';
import { useCSS } from '../../provider/CSSProvider';
import Searchbar from './Searchbar/Searchbar';
import { Acronyms } from './Acronyms/Acronyms';

function HeaderBar() {
  useCSS(style);

  return (
    <div id='HeaderBar'>
      <Acronyms />
      <Searchbar />
    </div>
  );
}

export default HeaderBar;
